// @index(d:!): export { default as ${variable}} from ${relpath}
export { default as TagsField } from './TagsField'
// /index

// @index(d:!): export type {Props as ${variable}Props} from ${relpath}
export type {Props as TagsFieldProps } from './TagsField'
// /index